import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { Icon } from "@iconify/react";
import { MenuItems } from "../../../../assets/store/navitems.store";
import { getActiveLinkIdentifier } from "../../../../core/utils/navitems.utils";
import { Theme } from "../../../themes/theme";
import LanguageDropdown from "../../dropdown/LanguageDropdown";
import Logo from "../../logo/Logo";

const Wrapper = styled.header`
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.03);
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

const MenuButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Theme.color.text.primary};
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  transition: all 0.3s ease;
  z-index: 110;
`;

const Drawer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: white;
  z-index: 120;
  padding: 24px;
  box-sizing: border-box;

  transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(-100%)")};

  transition: transform 0.3s ease;

  display: flex;
  flex-direction: column;
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const NavItems = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Item = styled.li`
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: ${({ $selected }) =>
    $selected ? Theme.color.text.primary : Theme.color.text.neutral};

  transition: color 0.25s ease;

  &:hover {
    color: ${Theme.color.text.primary};
  }
`;

function MobileNavbar() {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const active = getActiveLinkIdentifier(window.location.href);

  const handleNavigate = (href) => {
    navigate(href);
    setOpen(false);
  };

  return (
    <>
      <Wrapper>
        <Container>
          <Logo height="50px" />

          <MenuButton onClick={() => setOpen(true)}>
            <Icon icon="solar:hamburger-menu-linear" width="28" />
          </MenuButton>
        </Container>
      </Wrapper>

      <Overlay $open={open} onClick={() => setOpen(false)} />

      <Drawer $open={open}>
        <DrawerHeader>
          <Logo height="50px" />

          <MenuButton onClick={() => setOpen(false)}>
            <Icon icon="solar:close-circle-linear" width="28" />
          </MenuButton>
        </DrawerHeader>

        <NavItems>
          {MenuItems.map((item, key) => (
            <Item
              key={key}
              $selected={item.identifier.includes(active)}
              onClick={() => handleNavigate(item.href)}
            >
              {item.name}
            </Item>
          ))}
          <Item>
            <LanguageDropdown />
          </Item>
        </NavItems>
      </Drawer>
    </>
  );
}

export default MobileNavbar;
